import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserSessionPersistence, connectAuthEmulator, onAuthStateChanged, GoogleAuthProvider,
  signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword, updateProfile, signOut } from 'firebase/auth';
import { clientConfig } from '../configuration/client-config.js';
import { signInTestPlayer } from './test-accounts.js';
export type { User } from 'firebase/auth';
export async function createAccountService() {
  // Separate persistence namespaces prevent a real localhost account from
  // being restored into the emulator after switching development modes.
  const app = initializeApp(clientConfig.firebase, clientConfig.authEmulatorUrl ? 'nimblez-2-local-test' : '[DEFAULT]'), auth = getAuth(app);
  if (clientConfig.authEmulatorUrl) connectAuthEmulator(auth, clientConfig.authEmulatorUrl, { disableWarnings: true });
  await setPersistence(auth, browserSessionPersistence);
  async function register(email: string, password: string, displayName = email.split('@')[0].slice(0, 32)) {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(result.user, { displayName }); return result.user;
  }
  return {
    app, emulator: !!clientConfig.authEmulatorUrl,
    subscribe: (listener: Parameters<typeof onAuthStateChanged>[1]) => onAuthStateChanged(auth, listener),
    google: () => signInWithPopup(auth, new GoogleAuthProvider()),
    email: (email: string, password: string) => signInWithEmailAndPassword(auth, email, password),
    register,
    async testPlayer(slot: 1 | 2) {
      if (!clientConfig.authEmulatorUrl || clientConfig.firebase.projectId !== 'demo-nimblez-2') throw new Error('Test players require the isolated local authentication emulator.');
      return signInTestPlayer(slot, { register, signIn: async (email, password) => (await signInWithEmailAndPassword(auth, email, password)).user });
    },
    signOut: () => signOut(auth),
  };
}
